import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import VocabulariesFilters from './VocabulariesFilters';
import VocabularyCards from '../components/VocabularyCards';
import VocabulariesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabulariesPanelContainer';

const VocabulariesPanelNarrow = ({
  vocabularies,
  category,
  currentPage,
  pageSize,
  pageCount,
  total,
  fetchData,
  readStatus,
  readErrors,
  canEdit,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(vocabularies, { pageSize, total }));

  return (
    <VocabulariesPanelContainer
      readErrors={readErrors}
      canEdit={canEdit}
      className="aridhia-vocabularies-panel-narrow"
    >
      <div className="sticky-panel-header">
        <VocabulariesFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <VocabularyCards
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={vocabularies}
        itemsPerRow={1}
        readErrors={readErrors}
        readStatus={readStatus}
      />
    </VocabulariesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabulariesPanelNarrow);
